"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERX = void 0;
const aiPricing_1 = require("./aiPricing");
var ERX;
(function (ERX) {
  ERX.AIPricing = aiPricing_1.AIPricing;
})(ERX || (exports.ERX = ERX = {}));
